module.exports = __webpack_public_path__ + "static/media/suministros.83cc237c.jpg";